import * as React from "react";
import { Box, Typography } from "@mui/material";
import LocationOn from "@mui/icons-material/LocationOn";
import EventIcon from "@mui/icons-material/Event";
import moment from "moment";
import { marketingFonts } from "../../app/components/tickitMarketingTheme";
import { getBrandingColors, brandedTextSx } from "./brandingUtils";

const detailRowSx = {
  display: "flex",
  alignItems: "flex-start",
  gap: 1,
};

const detailTextSx = {
  fontFamily: marketingFonts.body,
  color: "inherit",
  fontSize: { xs: "0.8125rem", sm: "0.875rem" },
  lineHeight: 1.5,
  wordBreak: "break-word",
};

export default function EventDetailsStrip({ event, branding = {}, primaryColor, accentColor, dense = false }) {
  const colors = getBrandingColors({
    primaryColor: primaryColor || branding.primaryColor,
    accentColor: accentColor || branding.accentColor,
  });
  const accent = colors.accent;
  const iconColor = colors.primary;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: dense ? 0.75 : 1.25 }}>
      <Typography
        component="h2"
        sx={{
          fontFamily: marketingFonts.display,
          fontWeight: 800,
          fontSize: dense ? { xs: "1.05rem", sm: "1.15rem" } : { xs: "1.2rem", sm: "1.35rem" },
          lineHeight: 1.3,
          ...brandedTextSx(accent),
        }}
      >
        {event?.title}
      </Typography>
      <Box sx={{ ...detailRowSx, ...brandedTextSx(accent), opacity: 0.9 }}>
        <EventIcon sx={{ fontSize: 18, color: iconColor, mt: 0.15, flexShrink: 0 }} />
        <Typography variant="body2" sx={detailTextSx}>
          {moment(event?.date).format("dddd, MMMM D, YYYY · h:mm A")}
        </Typography>
      </Box>
      {event?.location && (
        <Box sx={{ ...detailRowSx, ...brandedTextSx(accent), opacity: 0.9 }}>
          <LocationOn sx={{ fontSize: 18, color: iconColor, mt: 0.15, flexShrink: 0 }} />
          <Typography variant="body2" sx={detailTextSx}>
            {event.location}
          </Typography>
        </Box>
      )}
      {!dense && event?.description && (
        <Typography
          variant="body2"
          sx={{
            fontFamily: marketingFonts.body,
            lineHeight: 1.7,
            mt: 0.5,
            fontSize: { xs: "0.8125rem", sm: "0.875rem" },
            ...brandedTextSx(accent),
            opacity: 0.85,
          }}
        >
          {event.description}
        </Typography>
      )}
    </Box>
  );
}
